import {
  ChangeDetectorRef,
  Component,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { BriefingsService, IBriefingDisplay } from '../../briefings.service';
import { BriefingFormDefinitionService } from '../briefing-form-definition.service';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { S3_URL_BASE } from 'src/environments/environment';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import {
  lastValueFrom,
  Observable,
  Subject,
  Subscription,
  take,
  takeUntil,
} from 'rxjs';
import { LegalPersonalityEnum } from 'src/app/domain/enums/legal-personality.enum';
import { ICustomer } from 'src/app/domain/customer/ICustomer';
import { CustomerService } from '../../../customers/crud-service';
import { PlanSelectionWizardComponent } from '../../../plans/plan-selection-wizard/plan-selection-wizard.component';
import { MatDialog } from '@angular/material/dialog';
import {
  SystemTypeEnum,
  SystemTypeIdEnum,
} from 'src/app/domain/registration/enums/system-type.enum';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { PlanSelectionService } from '../../../plans/plan-selection-wizard/plan-selection.service';
import {
  IPlanForSelection,
  ISystemModuleForSelection,
} from '../../../plans/plan-selection-wizard/plan-selection.models';
import { DialogConfirmComponent } from 'src/app/shared/components/dialog-confirm/dialog-confirm.component';
import { FormDataAnswersCreateCustomer } from '../../briefing-answers/formDataBuild/form-data-create-customer';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import { IContractSignature } from 'src/app/domain/registration/models/IContractSignature';
import { MatTableDataSource } from '@angular/material/table';
import { ContractsService } from '../../../contracts/crud-service';
import { ContractGenerationService } from '../../../contracts/services/contract-generation.service';
import { ContractSignatureType } from 'src/app/domain/enums/contract-signature-type.enum';
import {
  extractDocumentFromEntity,
  formatDocument,
} from 'src/app/shared/utils/document-formatter';
import { Meta, Title } from '@angular/platform-browser';
import { Clipboard } from '@angular/cdk/clipboard';
import { IContract } from 'src/app/domain/registration/models/IContract';

@Component({
  selector: 'app-briefing-response',
  templateUrl: './briefing-response.component.html',
  styleUrls: ['./briefing-response.component.sass'],
  providers: [PlanSelectionService, Clipboard],
})
export class BriefingResponseComponent implements OnInit {
  briefingId: string | null = null;
  briefing: IBriefingDisplay | null = null;
  briefingTitle: string = 'Briefing';
  formDefinition: IFieldConfig[] = [];
  responseForm: FormGroup;
  fileStepFormGroup!: FormGroup;
  BasicRegisterFormGroup!: FormGroup;
  addressRegisterFormGroup!: FormGroup;
  isLoading: boolean = true;
  isSubmitted: boolean = false;
  isRegister: boolean = false;
  isRegisterPartners: boolean = false;
  isRegisterCustomers: boolean = false;
  RegisterCustomer: boolean = false;
  HasPlan: boolean = false;
  fileExists: boolean = false;
  mandatoryPlan: boolean = false;
  selectedFiles: { [fieldName: string]: File[] } = {};
  imagePreviews: { [fieldName: string]: string[] } = {};
  inputTypeEnum = TypeComponentFieldEnum;
  selectedPlanName: string | null = null;
  selectedLegalPersonality: string | null = 'Pessoa Física';
  selectedFiscalEnvironment: string | null = 'HOMOLOGAÇÃO';
  allPlans: IPlanForSelection[] = [];
  contractCustomer: any;
  contractFlag: boolean = false;
  viewModalContract: boolean = false;
  partnersId: any;
  viewLinkContract: string = '';
  viewSignatures: boolean = false;
  generatedContractFlag: boolean = false;
  menssageCopyAll: string = '';
  systemModule: ISystemModuleForSelection[] = [];
  signatures = new MatTableDataSource<IContractSignature>([]);
  defaultContractedCustomer: any;
  private destroy$ = new Subject<void>();
  basicRegistrationFields: Set<string> = new Set();
  addressRegistrationFields: Set<string> = new Set();
  plansRegistrationFields: Set<string> = new Set();
  configPartnersRegistrationFields: Set<string> = new Set();

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private briefingsService: BriefingsService,
    private formDefinitionService: BriefingFormDefinitionService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
    private serviceCustomer: CustomerService,
    private dialog: MatDialog,
    private planSelectionService: PlanSelectionService,
    private contractsService: ContractsService,
    private contractGenerationService: ContractGenerationService,
    private titleService: Title,
    private clipboard: Clipboard,
    private metaService: Meta
  ) {
    this.responseForm = this.fb.group({});
  }

  ngOnInit(): void {
    this.briefingId = this.route.snapshot.paramMap.get('id');
    this.titleService.setTitle('Briefing');
    this.metaService.updateTag({ name: 'og:title', content: 'Briefing' });
    this.metaService.updateTag({
      name: 'og:image',
      content: 'assets/img/favicon.png',
    });
    if (this.briefingId) {
      this.loadBriefingAndForm();
    } else {
      this.isLoading = false;
      console.error('ID do Briefing não encontrado na rota.');
      this.toastService.showError('Não foi possível carregar o briefing.');
    }
  }
  disableFields() {
    this.responseForm.get('terminalQuantity')?.disable();
    this.responseForm.get('monthlyValue')?.disable();
    this.responseForm.get('dueDate')?.disable();
    this.responseForm.get('adhesionFee')?.disable();
  }

  loadBriefingAndForm(): void {
    this.isLoading = true;
    this.briefingsService.get(this.briefingId!).subscribe({
      next: (loadedBriefing) => {
        this.briefing = loadedBriefing;
        this.partnersId = this.briefing.partnerId;
        if (
          this.briefing.typeDescription === 'CADASTRO DO CLIENTE' ||
          this.briefing.typeDescription === 'CADASTRO DE PARCEIRO'
        )
          this.isRegister = true;
        if (this.briefing.typeDescription === 'CADASTRO DE PARCEIRO')
          this.isRegisterPartners = true;
        if (this.briefing.typeDescription === 'CADASTRO DO CLIENTE')
          this.isRegisterCustomers = true;

        if (this.briefing.mandatoryPlan) {
          this.mandatoryPlan = true;
        }

        this.briefingTitle = `Briefing: ${
          this.briefing.description || 'Sem descrição'
        } (Cód: ${this.briefing.code})`;
        const definition = this.formDefinitionService.getFormDefinition(
          this.briefing.type
        );
        if (definition) {
          this.formDefinition = definition;
          this.buildForm();
          this.precomputeFieldVisibility();
        } else {
          console.error(
            `Definição de formulário não encontrada para o tipo ${this.briefing.type}`
          );
          this.toastService.showError(
            'Tipo de formulário de briefing inválido.'
          );
        }
        this.isLoading = false;
        this.disableFields();
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Erro ao carregar dados do briefing:', error);
        this.toastService.showError('Erro ao carregar o briefing.');
        this.isLoading = false;
      },
    });
  }

  buildForm(): void {
    const formGroup: { [key: string]: any } = {};
    this.formDefinition.forEach((field) => {
      if (field.type !== this.inputTypeEnum.INPUT_FILE) {
        const validators = field.validation || [];
        formGroup[field.name] = [field.value || '', validators];
      }
    });
    this.responseForm = this.fb.group(formGroup);
  }

  getFieldConfig(name: string): any {
    return this.formDefinition.find((f) => f.name === name);
  }

  private precomputeFieldVisibility(): void {
    this.basicRegistrationFields.clear();
    this.addressRegistrationFields.clear();
    this.plansRegistrationFields.clear();
    this.configPartnersRegistrationFields.clear();

    const commonFields = [
      'legalPersonality',
      'cellPhone',
      'email',
      'webSite',
      'phone',
      'birthday',
      'tradingName',
      'contributorType',
      'regime',
      'mainActivity',
      'fiscalEnvironment',
    ];
    const pessoaFisicaFields = ['name', 'cpf', 'generalRegistration'];
    const pessoaJuridicaFields = [
      'companyName',
      'cnpj',
      'municipalRegistration',
      'stateRegistration',
    ];
    const productionSelectFields = ['csc', 'cscId'];
    const addressFields = [
      'cep',
      'state',
      'city',
      'address',
      'addressComplement',
      'addressNumber',
      'neighborhood',
    ];
    const planFields = [
      'plan',
      'type',
      'terminalQuantity',
      'monthlyValue',
      'dueDate',
      'adhesionFee',
      'systemModule',
      'deploymentValue',
    ];
    const configPartnerFields = [
      'supportContact',
      'cutoffDay',
      'transferDay',
      'webSiteLink',
      'comment',
    ];

    if (this.selectedLegalPersonality === 'Pessoa Física') {
      this.setToFisicPerson();
    } else if (this.selectedLegalPersonality === 'Pessoa Jurídica') {
      this.setToLegalPerson();
    }

    this.formDefinition.forEach((field) => {
      if (commonFields.includes(field.name)) {
        this.basicRegistrationFields.add(field.name);
      }
      if (
        productionSelectFields.includes(field.name) &&
        this.selectedFiscalEnvironment === 'PRODUÇÃO'
      ) {
        this.basicRegistrationFields.add(field.name);
      }
      if (
        this.selectedLegalPersonality === 'Pessoa Física' &&
        pessoaFisicaFields.includes(field.name)
      ) {
        this.basicRegistrationFields.add(field.name);
      }
      if (
        this.selectedLegalPersonality === 'Pessoa Jurídica' &&
        pessoaJuridicaFields.includes(field.name)
      ) {
        this.basicRegistrationFields.add(field.name);
      }
      if (addressFields.includes(field.name)) {
        this.addressRegistrationFields.add(field.name);
      }
      if (planFields.includes(field.name)) {
        this.plansRegistrationFields.add(field.name);
      }
      if (configPartnerFields.includes(field.name)) {
        this.configPartnersRegistrationFields.add(field.name);
      }
    });
  }

  isBasicRegistrationField(name: string): boolean {
    return this.basicRegistrationFields.has(name);
  }

  isAddressRegistrationField(name: string): boolean {
    return this.addressRegistrationFields.has(name);
  }

  isPlansRegistrationField(name: string): boolean {
    return this.plansRegistrationFields.has(name);
  }

  isConfigPartnersRegistrationField(name: string): boolean {
    return this.configPartnersRegistrationFields.has(name);
  }

  onLegalPersonalityChange(selectedOption: any) {
    if (
      selectedOption === 'Pessoa Física' ||
      selectedOption === 'Pessoa Jurídica'
    ) {
      this.selectedLegalPersonality = selectedOption;

      if (this.selectedLegalPersonality === 'Pessoa Física') {
        this.setToFisicPerson();
      } else if (this.selectedLegalPersonality === 'Pessoa Jurídica') {
        this.setToLegalPerson();
      }
      this.precomputeFieldVisibility();
    }
    if (selectedOption === 'PRODUÇÃO' || selectedOption === 'HOMOLOGAÇÃO') {
      this.selectedFiscalEnvironment = selectedOption;
      this.precomputeFieldVisibility();
    }
    console.log('Legal Personality Changed (from onSelect):', selectedOption);
    this.cdr.detectChanges();
  }

  private setToFisicPerson() {
    this.removeValidators('companyName', [
      Validators.required,
      Validators.min(4),
    ]);
    this.removeValidators('cnpj', [
      Validators.required,
      Validators.minLength(14),
    ]);

    this.addValidators('name', [Validators.required, Validators.min(4)]);
    this.addValidators('cpf', [Validators.required, Validators.minLength(11)]);
    this.addValidators('generalRegistration', [
      Validators.required,
      Validators.pattern(/\d+/),
    ]);
  }

  private setToLegalPerson() {
    this.addValidators('companyName', [Validators.required, Validators.min(4)]);
    this.addValidators('cnpj', [Validators.required, Validators.minLength(14)]);

    this.removeValidators('name', [
      Validators.required,
      Validators.minLength(4),
    ]);
    this.removeValidators('cpf', [
      Validators.required,
      Validators.minLength(11),
    ]);
    this.removeValidators('generalRegistration', [
      Validators.required,
      Validators.pattern(/\d+/),
    ]);
  }

  getSystemImageUrl(imagePath: string | undefined): string {
    if (!imagePath) {
      return 'assets/img/wazir/wazir-icon.svg';
    }
    return `${S3_URL_BASE}${imagePath}`;
  }

  onFileSelected(event: Event, fieldName: string): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const filesArray = Array.from(input.files);
      this.selectedFiles[fieldName] = filesArray;
      this.imagePreviews[fieldName] = [];

      filesArray.forEach((file) => {
        if (file.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            if (!this.imagePreviews[fieldName]) {
              this.imagePreviews[fieldName] = [];
            }
            this.imagePreviews[fieldName].push(e.target.result);
          };
          reader.readAsDataURL(file);
        }
      });
      this.fileExists = true;
      console.log(
        `Arquivos selecionados para ${fieldName}:`,
        this.selectedFiles[fieldName]
      );
    } else {
      this.selectedFiles[fieldName] = [];
      this.imagePreviews[fieldName] = [];
    }
    input.value = '';
    this.cdr.detectChanges();
  }

  clearFiles(fieldName: string): void {
    this.selectedFiles[fieldName] = [];
    this.imagePreviews[fieldName] = [];
    this.fileExists = false;
    this.cdr.detectChanges();
  }

  getFileIcon(fileType: string): string {
    if (fileType.startsWith('image/')) return 'image';
    if (fileType === 'application/pdf') return 'picture_as_pdf';
    if (fileType.includes('word')) return 'article';
    if (fileType.includes('spreadsheet') || fileType.includes('excel'))
      return 'analytics';
    if (fileType.includes('presentation') || fileType.includes('powerpoint'))
      return 'slideshow';
    if (fileType.includes('zip') || fileType.includes('rar'))
      return 'folder_zip';
    return 'insert_drive_file';
  }

  // Formata a informação sobre os tipos de arquivo aceitos para exibição mais amigável
  formatAcceptInfo(accept: string): string {
    if (!accept) return 'Todos os tipos';

    // Substitui wildcards de imagem por texto mais amigável
    let formatted = accept.replace('image/*', 'Imagens');

    // Formata extensões de arquivo para exibição mais limpa
    formatted = formatted.replace(/\./g, ' ');
    formatted = formatted.replace(/,/g, ', ');

    return formatted;
  }

  // Formata o tamanho do arquivo para uma exibição mais legível
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  async onSubmit(): Promise<void> {
    if (this.mandatoryPlan) {
      this.addValidators('plan', [Validators.required]);
      this.addValidators('type', [Validators.required]);
      this.addValidators('deploymentValue', [Validators.required]);
    }

    if (this.responseForm.invalid) {
      this.toastService.showError(
        'Por favor, preencha todos os campos obrigatórios.'
      );
      this.responseForm.markAllAsTouched();
      return;
    }

    // if(!this.fileExists && this.briefing?.typeDescription === 'CADASTRO DO CLIENTE'){
    //   this.toastService.showError('Por favor, envie nos arquivos sua foto do documento.');
    //   return;
    // }

    if (!this.briefingId) {
      this.toastService.showError('Erro: ID do Briefing não encontrado.');
      return;
    }

    this.isLoading = true;
    this.responseForm
      .get('partnerCommission')
      ?.setValue(this.briefing?.partner?.partnerCommission || 0);
    const formData = new FormData();
    if (this.isRegister) this.responseForm.get('registered')?.setValue(false);
    // Adiciona as respostas do formulário
    const formValues = this.responseForm.getRawValue();
    formValues.partnerId = this.briefing?.partnerId;
    if (this.briefing?.createdBy)
      formData.append('created_by', this.briefing.createdBy);

    // Log de quais campos de arquivo estão sendo enviados
    console.log(
      'Campos de arquivo a serem enviados:',
      Object.keys(this.selectedFiles)
    );

    // Adiciona cada arquivo diretamente com o nome do campo,
    // que deve corresponder aos nomes configurados no FileFieldsInterceptor no backend
    Object.keys(this.selectedFiles).forEach((fieldName) => {
      console.log(
        `Arquivos para o campo ${fieldName}:`,
        this.selectedFiles[fieldName].map((f) => `${f.name} (${f.type})`)
      );
      this.selectedFiles[fieldName].forEach((file) => {
        // Para FileFieldsInterceptor, os campos são enviados diretamente
        formData.append(fieldName, file, file.name);
      });
    });

    console.log('FormData preparado para envio - Detalhes no backend');
    if (this.RegisterCustomer) {
      if (this.contractFlag) {
        await this.addSignaturePartners(this.briefing);
        await this.addEntitySignature(formValues);
        await this.loadDefaultContractedCustomer();
      }
      try {
        await this.registerCustomer(formValues);
        formValues.registered = true;
      } catch (error: any) {
        this.isLoading = false;
        return;
      }
    }

    formData.append('answers', JSON.stringify(formValues));
    this.submitAnswers(this.briefingId, formData);
    // Usar a nova rota mais flexível que aceita qualquer campo de arquivo
  }
  private submitAnswers(id: any, formData: any): void {
    this.briefingsService.submitAnswersAnyFiles(id, formData).subscribe({
      next: () => {
        this.toastService.showSuccess('Briefing enviado com sucesso!');
        this.isSubmitted = true;
        this.isLoading = false;
        this.responseForm.disable();
        this.selectedFiles = {};
        this.imagePreviews = {};
      },
      error: (error: any) => {
        console.error('Erro ao enviar respostas:', error);
        this.toastService.showError(
          'Erro ao enviar o briefing. Tente novamente.'
        );
        this.isLoading = false;
      },
    });
  }
  private GenerateContract(data: any) {
    const contractData = {
      customerId: data.id,
      planId: data.customerPlans[0].id,
      systemId: data.customerPlans[0].system,
      partnerId: this.partnersId,
      consultantId: data.consultantId || null,
      representativeId: data.representativeId || null,
      counterId: data.representativeId || null,
      additionalSigners: this.signatures.data.map((sig) => ({
        name: sig.name,
        email: sig.email,
        document: sig.document,
        whatsAppNumber: sig.whatsAppNumber || '',
        role: this.getSignatureTypeLabel(sig.type),
        isDefaultContracted: sig.isDefaultContracted,
        isContracted: sig.isContracted,
      })),
    };
    this.contractGenerationService.generateContract(contractData).subscribe({
      next: (res: any) => {
        this.toastService.showSuccess(
          `Cadastro efetuado com sucesso. As informações para assinatura do contrato foram enviadas para ${res.customer.email}`
        );
        this.UpdateContractStatus(data.id);
      },
      error: (err: any) => {
        this.toastService.showError('Erro ao preparar dados: ' + (err || ''));
      },
    });
  }
  private UpdateContractStatus(id: string) {
    this.contractsService.updateAllContractsStatus(id, 'customer').subscribe({
      next: () => {
        this.getContracts(id);
      },
      error: (err: any) => {
        this.toastService.showError(
          'Erro ao carregar Contratos: ' + (err || '')
        );
      },
    });
  }
  private getContracts(id: string) {
    this.contractsService.getContractsByCustomer(id).subscribe({
      next: (res: any) => {
        console.log('Contratos atualizados com sucesso:', res);
        this.contractCustomer = res;
        this.viewSignatures = true;
        const firstContract = res[0];

        if (
          firstContract &&
          firstContract.signatures &&
          firstContract.signatures.length > 0
        ) {
          let links: any = [];
          firstContract.signatures.forEach((signature: any) => {
            if (signature.role && signature.signUrl) {
              links.push(`${signature.role}: ${signature.signUrl}`);
            }
          });
          this.menssageCopyAll = links.join('\n');
        } else {
          this.menssageCopyAll = 'Nenhum link de assinatura encontrado.';
        }
      },
      error: (err: any) => {
        this.toastService.showError(
          'Erro ao carregar Contratos: ' + (err || '')
        );
      },
    });
  }

  protected copyAllLinks(): void {
    if (this.menssageCopyAll) {
      this.clipboard.copy(this.menssageCopyAll);
      this.toastService.showSuccess(
        'Todos os links copiados para a área de transferência.'
      );
    } else {
      this.toastService.showError('Nenhum link disponível para copiar.');
    }
  }

  private async registerCustomer(element: any): Promise<any> {
    try {
      Object.keys(this.selectedFiles).forEach((fieldName) => {
        this.selectedFiles[fieldName].forEach((file) => {
          if (fieldName === 'digitalDocument') element.digitalDocument = file;
          if (fieldName === 'image') element.image = file;
          if (fieldName === 'documentPhoto') element.documentPhoto = file;
        });
      });
      let formDataCreator = new FormDataAnswersCreateCustomer();
      const formData = await formDataCreator.build(element);
      const data = await lastValueFrom(
        this.serviceCustomer.createWithFormData(formData)
      );
      if (this.contractFlag) {
        this.GenerateContract(data);
      }
      return data;
    } catch (error: any) {
      //this.toastService.showError('Erro ao preparar dados: ' + (error.message || ''));
      console.error('Erro ao construir FormData:', error, error.mensage);
      this.signatures.data = [];
      throw error;
    }
  }

  protected copyLinkContract(link: string): void {
    if (link) {
      this.clipboard.copy(link);
      this.toastService.showSuccess(
        'Link copiado para a área de transferência.'
      );
    } else {
      this.toastService.showError('Nenhum link disponível para copiar.');
    }
  }
  protected sendWhatsAppLink(phone?: string, link?: string): void {
    if (link && phone !== '' && phone !== undefined) {
      const message = `Olá, segue o link do contrato: ${link}`;
      const whatsAppLink = this.generateWhatsAppLink(phone, message);
      window.open(whatsAppLink, '_blank');
    } else {
      this.toastService.showError('Nenhum link disponível para enviar.');
    }
  }

  private generateWhatsAppLink(phone: string, message: string): string {
    let cleanPhone = phone.replace(/\D/g, '');
    if (!cleanPhone.startsWith('55')) {
      cleanPhone = '55' + cleanPhone;
    }
    return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
  }
  protected openlinkContract(link: string): void {
    if (link) {
      window.open(link, '_blank');
    }
  }
  public onChangeCep() {
    const value = this.responseForm.get('cep')?.value;
    if (value && value.length === 8) {
      this.serviceCustomer
        .getCepInfo(value)
        .pipe(take(1))
        .subscribe((result: ICustomer) => {
          this.getCitiesByUf(result.state)
            .pipe(take(1))
            .subscribe((resp: any) => {
              this.responseForm.get('city')?.reset();
              this.getFieldConfig('city').options = resp.map(
                (v: any) => v.nome
              );

              this.responseForm.patchValue({
                ...result,
              });
            });
        });
    }
  }
  public getCitiesByUf(uf?: any): Observable<any> {
    const state = uf || this.responseForm.get('state')?.value;
    this.responseForm.get('city')?.reset();

    return this.serviceCustomer.getCitiesByUf(state);
  }

  private addValidators(name: any, fn: any) {
    const control = this.responseForm.get(name);
    control?.addValidators(fn);
    control?.updateValueAndValidity({ emitEvent: false });
  }
  private removeValidators(name: any, fn: any) {
    const control = this.responseForm.get(name);
    control?.removeValidators(fn);
    control?.updateValueAndValidity({ emitEvent: false });
  }

  public loadPlans(name: string): void {
    const value = this.responseForm.get('type')?.value;
    //Limpando campos caso mudar a seleção do tipo ou dos Planos
    if (name === 'type' || name === 'plan') {
      this.responseForm.get('terminalQuantity')?.reset();
      this.responseForm.get('monthlyValue')?.reset();
      this.responseForm.get('dueDate')?.reset();
      this.responseForm.get('adhesionFee')?.reset();
      this.responseForm.get('systemModule')?.reset();
    }

    // Convertendo a string para o tipo que o enum espera
    const systemTypeName = value as keyof typeof SystemTypeIdEnum;
    // Acessando o valor numérico (ID) a partir do nome
    const systemTypeId = SystemTypeIdEnum[systemTypeName];

    const serviceFilters: { systemType?: number; partnerIds?: string[] } = {};
    if (this.briefing?.createdBy || this.briefing?.partnerId) {
      serviceFilters.partnerIds = [
        this.briefing?.createdBy || this.briefing?.partnerId,
      ];
    }
    serviceFilters.systemType = systemTypeId;
    if (name === 'type') {
      this.responseForm.get('plan')?.reset();
      this.planSelectionService
        .getAvailablePlans(serviceFilters)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (plans) => {
            if (plans.length === 0)
              this.toastService.showInfo(
                'Não existe Planos para o TIPO:' + value
              );
            this.allPlans = plans;
            this.getFieldConfig('plan').options = plans.filter(
              (plan) => plan.isActive
            );
            this.cdr.markForCheck();
          },
          (error) => {
            console.error(
              '[PlanSelectionWizard] Erro ao carregar planos:',
              error
            );
            this.cdr.markForCheck();
          }
        );
    }
    if (name === 'plan') {
      const systemValue = this.responseForm.get('plan')?.value;
      const planoEncontrado = this.allPlans.find(
        (plano) => plano.id === systemValue.id
      );
      if (planoEncontrado) {
        const terminalQuantity = planoEncontrado.terminalQuantity;
        const monthlyValue = planoEncontrado.monthlyValue;
        const dueDate = planoEncontrado.dueDate;
        const adhesionFee = planoEncontrado.adhesionFee;
        const isDaysCount = planoEncontrado.isDaysCount;
        const modulesObjetec = this.loadModule(planoEncontrado.systemId);
        modulesObjetec.subscribe((modules) => {
          if (modules.length > 0) {
            this.responseForm.get('systemModule')?.enable();
            this.getFieldConfig('systemModule').options = modules;
          } else {
            this.responseForm.get('systemModule')?.disable();
            this.toastService.showInfo('Não existe Módulos para esse Sistema');
          }
        });
        this.responseForm.get('terminalQuantity')?.setValue(terminalQuantity);
        this.responseForm.get('monthlyValue')?.setValue(monthlyValue);
        this.responseForm.get('dueDate')?.setValue(dueDate);
        this.responseForm.get('adhesionFee')?.setValue(adhesionFee);

        const dayMonth = new Date().getDate();
        let dueInDays = 0;

        if (isDaysCount && dueDate) {
          dueInDays =
            dayMonth > dueDate ? 30 - dayMonth + dueDate : dueDate - dayMonth;
        }
        const daysCountQuantity = (+monthlyValue / 30) * +dueInDays;
        this.responseForm.get('dueInDays')?.setValue(dueInDays);
        this.responseForm.get('daysCountValue')?.setValue(daysCountQuantity);
        this.responseForm.get('fullPlan')?.setValue(planoEncontrado);
      } else {
        console.log(
          'Nenhum plano foi encontrado com o systemName especificado.'
        );
      }
    }
  }

  loadModule(idSystem: any): Observable<any> {
    return this.planSelectionService.getAvailableModules(idSystem);
  }

  public generateContractModal() {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: DialogConfirmComponent,
      data: {
        title: `Deseja cadastrar e gerar Contrato ao Cliente?`,
        content:
          'O contrato será gerado e encaminhado para seu email e relacionados.',
        noText: 'Somente cadastro',
        yesText: 'Sim, gerar contrato',
      },
      callBack: (confirmResult: any) => {
        if (confirmResult) {
          this.contractFlag = true;
          this.RegisterCustomer = true;
          this.onSubmit();
          this.generatedContractFlag = true;
        } else {
          this.contractFlag = false;
          this.RegisterCustomer = true;
          this.onSubmit();
        }
      },
    });
  }
  MultipleSelect(name: string): boolean {
    return name === 'systemModule';
  }
  //RELACIONADOS AOS CONTRATOS DOS CLIENTES

  private async loadDefaultContractedCustomer(): Promise<any> {
    try {
      const defaultCustomer: any = await lastValueFrom(
        this.contractGenerationService.getDefaultContractedCustomer()
      );
      if (defaultCustomer && defaultCustomer.id) {
        console.log(
          '✅ Cliente padrão (contratada) carregado:',
          defaultCustomer
        );
        this.defaultContractedCustomer = defaultCustomer;
        this.addContractedSignature(defaultCustomer);
      } else {
        console.warn('⚠️ Cliente padrão (contratada) não encontrado');
      }
      return defaultCustomer;
    } catch (error) {
      console.error('❌ Erro ao carregar cliente padrão (contratada):', error);
      throw error;
    }
  }

  private async addContractedSignature(defaultCustomer: any) {
    if (!defaultCustomer) return;

    // Extrair e formatar documento
    const documento = extractDocumentFromEntity(defaultCustomer);
    const documentoFormatado = formatDocument(documento);

    const contractedSignature: IContractSignature = {
      code: 'CONTRATADA',
      name:
        defaultCustomer.name ||
        defaultCustomer.companyName ||
        defaultCustomer.tradingName,
      email: defaultCustomer.email,
      document: documentoFormatado,
      whatsAppNumber: defaultCustomer.whatsAppNumber || '',
      type: ContractSignatureType.CONTRATADA,
      status: 'PENDENTE',
      isContracted: false,
      isDefaultContracted: true, // Flag especial para indicar que é a contratada padrão
      customerId: '0', // Identificar como cliente padrão
    };

    console.log('📋 Assinatura da contratada adicionada:', {
      nome: contractedSignature.name,
      documento: documento,
      documentoFormatado: contractedSignature.document,
      email: contractedSignature.email,
    });

    // Adicionar ao início das assinaturas para destacar
    this.signatures.data = [contractedSignature, ...this.signatures.data];
  }

  private async addEntitySignature(data: any) {
    if (!data) {
      console.error('Dados da entidade não encontrados');
      return;
    }

    console.log('📱 Dados da entidade para assinatura:', {
      name: data.name,
      email: data.email,
      document: data.document,
      cpf: data.cpf,
      cnpj: data.cnpj,
      phone: data.phone,
      cellPhone: data.cellPhone,
    });

    // Extrair e formatar documento
    const documento = extractDocumentFromEntity(data);
    const documentoFormatado = formatDocument(documento);

    // Buscar o telefone com prioridade para celular
    const telefone = data.cellPhone || data.phone || '';

    const entitySignature: IContractSignature = {
      code: '001',
      name: data.name || 'Cliente',
      email: data.email || '',
      document: documentoFormatado,
      whatsAppNumber: telefone,
      type: ContractSignatureType.CONTRATANTE,
      status: 'PENDENTE',
      isContracted: true,
      isDefaultContracted: false,
    };

    console.log('📋 Assinatura do cliente criada:', {
      nome: entitySignature.name,
      documento: documento,
      documentoFormatado: entitySignature.document,
      email: entitySignature.email,
    });

    this.signatures.data = [...this.signatures.data, entitySignature];
  }
  private async addSignaturePartners(data: any) {
    const documento = data.partner.cpf || data.partner.cnpj;

    const partnerSignature: IContractSignature = {
      code: '003',
      name:
        data.partner.name ||
        data.partner.companyName ||
        data.partner.tradingName ||
        'Sem Nome',
      email: data.partner.email,
      document: documento,
      whatsAppNumber: data.partner.cellPhone || data.partner.phone || '',
      type: ContractSignatureType.PARCEIRO,
      status: 'PENDENTE',
      isContracted: false,
    };

    console.log('📋 Assinatura do parceiro adicionada:', partnerSignature);
    this.signatures.data = [...this.signatures.data, partnerSignature];
  }

  getSignatureTypeLabel(type: ContractSignatureType): string {
    if (typeof type === 'string') {
      return type;
    }

    const typeName = Object.keys(ContractSignatureType).find(
      (key) =>
        ContractSignatureType[key as keyof typeof ContractSignatureType] ===
        type
    );

    return typeName || 'Desconhecido';
  }
}
